import BaseApi from './BaseApi';

export type AccountState = {
  accountId: string;
  isInactive: boolean;
};
/**
 * アカウントの有効状態設定API。
 */
class UpdateUserStateApi extends BaseApi {
  async update(params: AccountState) {
    return await this.execute('updateUserStatusApi', {
      method: 'POST',
      body: params
    }).then(({ status }) => status === 1);
  }
}

export default UpdateUserStateApi;
